import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem('tokenInv');

  return token ? element : <Navigate to="/" replace />;
};

export default ProtectedRoute;
